var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "38", height: "38", viewBox: "0 0 38 38", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("rect", { id: "path-1", width: "38", height: "38", rx: "4" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { stroke: "#9A660A", strokeWidth: "2.5", cx: "14", cy: "15", r: "3" }),
      React.createElement("path", { fill: "#9A660A", d: "M25.115 10.89h3.205L12.503 28.002l-3.164-.118z" }),
      React.createElement("circle", { stroke: "#9A660A", strokeWidth: "2.5", cx: "24", cy: "24", r: "3" })
    )
  );
});